import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterListIcon from "@mui/icons-material/FilterList";
import RefreshIcon from "@mui/icons-material/Refresh";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import { LoaderComponent } from "../../components/Loader/LoaderComponent.js";

import {
  Typography,
  Box,
  Button,
  Grid,
  Card,
  Badge,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // Table,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "../../components/snackbar/index.tsx";

import { styled } from "@mui/material/styles";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import {
//   GridToolbarContainer,
//   GridToolbarFilterButton,
//   GridFooter,
//   GridToolbarColumnsButton,
//   GridActionsCellItem,
// } from "@mui/x-data-grid";
import AnimatedNumber from "animated-number-react";
import clsx from "clsx";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { addUsersThunk, getAllUsersThunk, usersThunk } from "./reducer/thunk";
import AdvanceSearchModal from "./advanceSearchModal";
import { updateTokenIfExpired } from "../../utility/SessionManager";
import Methods, { validateAPI } from "../../utility/Methods";
import AddUserModal from "./addUserModal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Backdrop from "../../components/backdrop/index.tsx";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import constants from "../../common/constants.js";

// import { LoaderComponent } from "../../components/loader/LoaderComponent";

const StyledTotalCard = styled(Card)(({ theme }) => ({
  height: "100px",
  paddingLeft: "40px",
  paddingRight: "40px",
  marginRight: "40px",
  marginBottom: "40px",
  minWidth: "100px",
  backgroundColor: "#ffffff",
  color: "#000",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  aliignItems: "center",
}));

// const customToolbar = () => {
//   return (
//     <GridToolbarContainer>
//       <GridToolbarColumnsButton />
//       <GridToolbarFilterButton />
//     </GridToolbarContainer>
//   );
// };

const Users = () => {
  const navigate = useNavigate();
  const role = Methods.getRole();
  const [usersList, setUsersList] = useState([]);
  const [showclaimType, setShowClaimType] = useState(false);
  const [statusFilter, setStatusFilter] = useState([]);
  const [openCount, setSnackbarOpenCount] = useState(0);
  const [inProgressCount, setInProgressCount] = useState(0);
  const [closedCount, setClosedCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [openFilter, setSnackbarOpenFilter] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [advanceSearchModalOpen, setAdvanceSearchModalOpen] = useState(false);
  const [addUserModalOpen, setAddUserModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [rowToEdit, setRowToEdit] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [assetsList, setAssetsList] = useState([]);
  const [reportsToList, setReportsToList] = useState([]);
  const [formInitialValues, setFormInitialValues] = useState({
    name: "",

    employeeId: "",
    userName: "",
    designation: "",
    department: "",
    track: "",
    reportsTo: "",
    dojTimeRange: {
      from: "",
      to: "",
    },
    emailId: "",
  });
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 20,
    page: 0,
  });

  const allRequests = useSelector((state) => state.users.users);
  const addUpdateUsers = useSelector((state) => state.users.addUsers);
  const getAllUsers = useSelector((state) => state.users.getAllUsers);
  // const allAssetsList = useSelector((state) => state.assets.assetsList);

  const [rowCount, setRowCount] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });
  const {
    status: allRequestsStatus,
    data: allRequestsData,
    error: allRequestsError,
  } = allRequests;

  const {
    status: addUpdateUsersStatus,
    data: addUpdateUsersData,
    error: addUpdateUsersError,
  } = addUpdateUsers;

  // const {
  //   status: allAssetsListStatus,
  //   data: allAssetsListData,
  //   error: allAssetsListError,
  // } = allAssetsList;

  const {
    status: getAllUsersStatus,
    data: getAllUsersData,
    error: getAllUsersError,
  } = getAllUsers;

  const handleClick = () => {
    setSnackbarOpen({ open: false, severity: "", message: "" });
  };

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity: severity,
      message: message,
    });
  };
  const dispatchAPICall = (data) => {
    updateTokenIfExpired(window, dispatch);
    dispatch(usersThunk(data));
  };

  useEffect(() => {
    dispatchAPICall({
      name: formInitialValues?.name || "",

      employeeId: formInitialValues?.employeeId || "",
      userName: formInitialValues?.userName || "",
      designation: formInitialValues?.designation || "",
      department: formInitialValues?.department || "",
      track: formInitialValues?.track || "",
      reportsTo: formInitialValues?.reportsTo || "",
      dojTimeRange: {
        from: formInitialValues?.dojTimeRange?.from || "",
        to: formInitialValues?.dojTimeRange?.to || "",
      },
      emailId: formInitialValues?.emailId || "",

      page: 0,
      size: paginationModel.pageSize,
    });
  }, [formInitialValues, addUpdateUsersStatus]);

  useEffect(() => {
    //to backend added in all API calls if token expired case
    validateAPI(
      allRequestsError?.status,
      allRequestsError?.error?.errorCode,
      dispatch,
      navigate
    );
    if (allRequestsStatus === "succeeded") {
      const listData = allRequestsData?.userList?.content;
      const listCount = allRequestsData?.userList?.totalElements;
      // setSnackbarOpenCount(allRequestsData?.newCount);
      // setClosedCount(allRequestsData?.closedCount);
      // setInProgressCount(allRequestsData?.inProgressCount);
      // setTotalCount(allRequestsData?.totalCount);
      setUsersList(listData);
      setRowCount(listCount);
    }
  }, [allRequestsStatus]);

  useEffect(() => {
    if (addUpdateUsersStatus === "succeeded") {
      handleShowSnackbar("success", addUpdateUsersData);
    } else if (addUpdateUsersStatus === "failed") {
      console.log("addUpdateUsersError", addUpdateUsersError);
      handleShowSnackbar("error", addUpdateUsersError?.error?.errorMessage);
    }
  }, [addUpdateUsersStatus]);

  useEffect(() => {
    dispatch(getAllUsersThunk({}));
  }, []);

  // useEffect(() => {
  //   if (allAssetsListStatus === "succeeded") {
  //     setAssetsList(allAssetsListData);
  //   }
  // }, [allAssetsListStatus]);

  useEffect(() => {
    if (getAllUsersStatus === "succeeded") {
      setReportsToList(getAllUsersData);
    }
  }, [getAllUsersStatus]);

  const advanceSearchModalHandler = () => {
    setAdvanceSearchModalOpen(false);
  };

  const addUserModalHandler = () => {
    setAddUserModalOpen(false);
    setRowToEdit(null);
  };

  const submitClickHandler = async (values) => {
    console.log("users values", values);
    setFormInitialValues(values);
    setPaginationModel({
      page: 0,
      pageSize: paginationModel.pageSize,
    });
    advanceSearchModalHandler();
  };

  const submitAddUserForm = async (values) => {
    let updatedVal = {};
    Object.assign(updatedVal, values); //copy the original object to the new object
    updatedVal["assetNameList"] = values.assetNameList.join(",");
    dispatch(addUsersThunk(updatedVal));
    addUserModalHandler();
    dispatchAPICall({
      name: formInitialValues?.name,

      employeeId: formInitialValues?.employeeId,
      userName: formInitialValues?.userName,
      designation: formInitialValues?.designation,
      department: formInitialValues?.department,
      track: formInitialValues?.track,
      reportsTo: null,
      dojTimeRange: {
        from: formInitialValues?.dojTimeRange?.from,
        to: formInitialValues?.dojTimeRange?.to,
      },
      emailId: formInitialValues?.emailId,
      page: 0,
      size: paginationModel.pageSize,
    });
  };

  const handleDelete = (row) => {
    let updatedVal = {};
    Object.assign(updatedVal, row); //copy the original object to the new object
    updatedVal["isDeleted"] = true;
    //!dispatch delete action
    dispatch(addUsersThunk(updatedVal));
    setDeleteModalOpen(false);
    setRowToDelete(null);
    dispatchAPICall({
      name: formInitialValues?.name,

      employeeId: formInitialValues?.employeeId,
      userName: formInitialValues?.userName,
      designation: formInitialValues?.designation,
      department: formInitialValues?.department,
      track: formInitialValues?.track,
      reportsTo: null,
      dojTimeRange: {
        from: formInitialValues?.dojTimeRange?.from,
        to: formInitialValues?.dojTimeRange?.to,
      },
      emailId: formInitialValues?.emailId,
      page: 0,
      size: paginationModel.pageSize,
    });
  };

  const handleFilterReset = () => {
    setFormInitialValues({
      ...formInitialValues,
      name: "",
      employeeId: "",
      userName: "",
      designation: "",
      department: "",
      track: "",
      reportsTo: null,
      dojTimeRange: {
        from: "",
        to: "",
      },
      emailId: "",
    });
    setFiltersApplied(false);

    setPaginationModel({
      page: 0,
      pageSize: paginationModel.pageSize,
    });
    advanceSearchModalHandler();
  };

  // const tableHeader = [
  //   {
  //     field: "actions",
  //     type: "actions",
  //     headerName: "Actions",
  //     width: 200,
  //     cellClassName: "actions",
  //     getActions: ({ row }) => [
  //       <GridActionsCellItem
  //         icon={
  //           <Tooltip title="Edit">
  //             <EditIcon />
  //           </Tooltip>
  //         }
  //         label="Edit"
  //         className="textPrimary"
  //         onClick={() => {
  //           setAddUserModalOpen(true);
  //           setRowToEdit(row);
  //         }}
  //         color="primary"
  //       />,
  //       <GridActionsCellItem
  //         icon={
  //           <Tooltip title="Delete">
  //             <DeleteIcon />
  //           </Tooltip>
  //         }
  //         label="Delete"
  //         className="textPrimary"
  //         onClick={() => {
  //           setDeleteModalOpen(true);
  //           setRowToDelete(row);
  //         }}
  //         color="error"
  //       />,
  //     ],
  //   },
  //   { field: "name", headerName: "Full Name", width: 200, type: "string" },

  //   {
  //     field: "employeeId",
  //     headerName: "Employee ID",
  //     width: 200,
  //     type: "string",
  //   },
  //   { field: "userName", headerName: "Username", width: 200, type: "string" },
  //   {
  //     field: "designation",
  //     headerName: "Designation",
  //     width: 200,
  //     type: "string",
  //   },
  //   {
  //     field: "department",
  //     headerName: "Department",
  //     width: 200,
  //     type: "string",
  //   },
  //   { field: "track", headerName: "Track", width: 200, type: "string" },
  //   {
  //     field: "reportsTo",
  //     headerName: "Reports To (ID)",
  //     width: 200,
  //     type: "number",
  //   },
  //   {
  //     field: "dob",
  //     headerName: "Date of Birth",
  //     width: 200,
  //     type: "string",
  //     renderCell: (value) => {
  //       return Methods.formatDate(value?.row?.dob);
  //     },
  //   },
  //   {
  //     field: "doj",
  //     headerName: "Date of Joining",
  //     width: 200,
  //     type: "string",
  //     renderCell: (value) => {
  //       return Methods.formatDate(value?.row?.doj);
  //     },
  //   },
  //   { field: "emailId", headerName: "Email ID", width: 250, type: "string" },
  //   {
  //     field: "phoneNumber",
  //     headerName: "Phone Number",
  //     width: 200,
  //     type: "string",
  //   },
  //   { field: "role", headerName: "Role", width: 200, type: "string" },
  //   { field: "active", headerName: "Active", width: 150, type: "boolean" },
  //   {
  //     field: "assetNameList",
  //     headerName: "Assets List",
  //     width: 200,
  //     type: "string",
  //   },
  // ];

  // const roleBasedAccess = () => {
  //   if (role === constants.USER) {
  //     tableHeader.splice(0, 1);
  //   }
  // };

  // roleBasedAccess();

  const cardClickEvent = (name) => {
    let status = "";
    if (name === "New") {
      status = name;
    } else if (name === "InProgress") {
      status = name;
    } else if (name === "Closed") {
      status = name;
    } else {
      status = "";
    }
    setFormInitialValues({
      ...formInitialValues,
      status: status,
    });
  };

  const handleCloseFilter = () => {
    setSnackbarOpenFilter(false);
  };

  const escapeRegExp = (value) => {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    // We have the cursor, we can allow the page transition.
    const reqBody = {
      name: formInitialValues?.name,

      employeeId: formInitialValues?.employeeId,
      userName: formInitialValues?.userName,
      designation: formInitialValues?.designation,
      department: formInitialValues?.department,
      track: formInitialValues?.track,
      reportsTo: null,
      dojTimeRange: {
        from: formInitialValues?.dojTimeRange?.from,
        to: formInitialValues?.dojTimeRange?.to,
      },
      emailId: formInitialValues?.emailId,
      page: newPaginationModel.page,
      size: newPaginationModel.pageSize,
    };
    dispatchAPICall(reqBody);
    setPaginationModel({
      page: newPaginationModel.page,
      pageSize: newPaginationModel.pageSize,
    });
  };

  return (
    <Card
      sx={{
        flex: 1,
        borderRadius: "10px",
        width: "100%",
        display: "flex",
        // border: "2px solid rgb(245, 132, 31)",
        // boxShadow: "rgb(245, 132, 31) 0px 2px 10px",
      }}
    >
      {allRequestsStatus === "pending" ? <Backdrop /> : null}
      {addUpdateUsersStatus === "pending" ? <Backdrop /> : null}

      {/* {showLoader && <LoaderComponent />} */}
      <Grid container md={12} xs={12}>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            borderRadius: "10px",
            justifyContent: "center",
            padding: 3,
          }}
        >
          <Box
            sx={{
              width: "100%",
              "& .super-app.red": {
                backgroundColor: "#FD4532",
                color: "#FFF",
              },
              "& .super-app.green": {
                backgroundColor: "#50B948",
                color: "#FFF",
              },
              "& .super-app.yellow": {
                backgroundColor: "#FCB43C",
                color: "#FFF",
              },
              "& .super-app.new": {
                backgroundColor: "#0284C9",
                color: "#FFF",
              },
            }}
          >
            {/* <Grid
              container
              justifyContent={"space-between"}
              sx={{
                width: "100%",
                display: "flex",
                marginBottom: "20px",
                mt: 2,
              }}
            >
              <Grid item md={3} sx={{ pl: 1, pr: 1 }}>
                <StyledTotalCard
                  onClick={() => cardClickEvent("")}
                  sx={{ cursor: "pointer", borderLeft: "10px solid blue" }}
                >
                  <Typography align={"center"} variant={"h3"}>
                    {totalCount}
                  </Typography>
                  <Typography align={"center"} variant={"h6"}>
                    {"Total "}
                  </Typography>
                </StyledTotalCard>
              </Grid>

               <Grid item md={3} sx={{ pl: 1, pr: 1 }}>
                <StyledTotalCard
                  onClick={() => cardClickEvent("New")}
                  sx={{ cursor: "pointer", borderLeft: "10px solid #0284C9" }}
                >
                  <Typography align={"center"} variant={"h3"}>
                    {openCount}
                  </Typography>
                  <Typography align={"center"} variant={"h6"}>
                    {"New"}
                  </Typography>
                </StyledTotalCard>
              </Grid>
              <Grid item md={3} sx={{ pl: 1, pr: 1 }}>
                <StyledTotalCard
                  onClick={() => cardClickEvent("InProgress")}
                  sx={{ cursor: "pointer", borderLeft: "10px solid #FCB43C" }}
                >
                  <Typography align={"center"} variant={"h3"}>
                    {inProgressCount}
                  </Typography>
                  <Typography align={"center"} variant={"h6"}>
                    {"In Progress "}
                  </Typography>
                </StyledTotalCard>
              </Grid>
              <Grid item md={3} sx={{ pl: 1, pr: 1 }}>
                <StyledTotalCard
                  onClick={() => cardClickEvent("Closed")}
                  sx={{ borderLeft: "10px solid #50B948", cursor: "pointer" }}
                >
                  <Typography align={"center"} variant={"h3"}>
                    {closedCount}
                  </Typography>
                  <Typography align={"center"} variant={"h6"}>
                    {"Closed "}
                  </Typography>
                </StyledTotalCard>
              </Grid> 
            </Grid> */}
            <Grid
              container
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              spacing={2}
            >
              <Grid item>
                <Typography variant="h3" sx={{ mb: 2 }}>
                  Users
                </Typography>
              </Grid>

              <Grid item>
                {filtersApplied ? (
                  <Button
                    variant="contained"
                    sx={{
                      mb: "20px",
                      cursor: "pointer",
                      mr: 2,
                      // background: "rgb(245, 132, 31)",
                    }}
                    onClick={() => handleFilterReset()}
                  >
                    Reset filters
                  </Button>
                ) : null}
                <Badge
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  badgeContent={filtersApplied ? "!" : 0}
                  color="error"
                >
                  <Button
                    variant="contained"
                    sx={{
                      mb: "20px",
                      cursor: "pointer",
                      mr: 2,
                      background: "rgb(245, 132, 31)",
                    }}
                    onClick={(event) => {
                      setAdvanceSearchModalOpen(true);
                    }}
                    startIcon={<FilterListIcon />}
                  >
                    Advanced Filters
                  </Button>
                </Badge>
                {role !== constants.USER && (
                  <Button
                    variant="contained"
                    sx={{
                      mb: "20px",
                      cursor: "pointer",
                      background: "rgb(245, 132, 31)",
                    }}
                    onClick={(event) => {
                      setAddUserModalOpen(true);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Add User
                  </Button>
                )}
              </Grid>
            </Grid>
            {/* <DataGrid
              sx={(theme) => {
                return {
                  height: "500px",
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "#0284c9",
                    color: "#fff",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    textOverflow: "clip",
                    fontWeight: "bold",
                    fontSize: "16px",
                    whiteSpace: "break-spaces !important",
                    lineHeight: 1,
                  },
                  "& .MuiDataGrid-cell": {
                    textOverflow: "clip",
                    whiteSpace: "break-spaces !important",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    [theme.breakpoints.down(600)]: {
                      display: "block",
                    },
                  },
                  "& .MuiTablePagination-select": {
                    [theme.breakpoints.down(600)]: {
                      marginRight: "10px",
                      marginLeft: "2px",
                    },
                  },
                  "& .MuiDataGrid-row": {
                    // marginTop: "5px",
                    // marginBottom: "5px",
                  },
                  "& .MuiTablePagination-actions": {
                    [theme.breakpoints.down(600)]: {
                      marginLeft: "5px",
                    },
                  },
                };
              }}
              slots={{
                toolbar: GridToolbar,
              }}
              slotProps={{
                columnsManagement: {
                  disableColumnFilter: true,
                  disableShowHideToggle: true,
                  disableResetButton: true,
                },
              }}
              // getRowId={usersList.userId}
              paginationModel={paginationModel}
              rowCount={rowCount}
              paginationMode="user"
              onPaginationModelChange={handlePaginationModelChange}
              pageSizeOptions={[5, 10, 20, 50, 100]}
              // components={{ LoadingOverlay: Backdrop }}
              hideFooterSelectedRowCount={true}
              // rows={filteredRows.length !== 0 ? filteredRows : usersList}
              rows={usersList}
              columns={tableHeader}
              getRowId={(row) => row.userId}
            /> */}
          </Box>
        </Grid>
        {advanceSearchModalOpen && (
          <AdvanceSearchModal
            open={advanceSearchModalOpen}
            openHandler={advanceSearchModalHandler}
            formInitialValues={formInitialValues}
            submitClickHandler={submitClickHandler}
            handleFilterReset={handleFilterReset}
            setFiltersApplied={setFiltersApplied}
            reportsToList={reportsToList}
          />
        )}
        {addUserModalOpen && (
          <AddUserModal
            open={addUserModalOpen}
            openHandler={addUserModalHandler}
            rowToEdit={rowToEdit}
            submitClickHandler={submitAddUserForm}
            assetsList={assetsList}
            reportsToList={reportsToList}
            //  handleFilterReset={handleFilterReset}
            //  setFiltersApplied={setFiltersApplied}
          />
        )}

        <Dialog
          open={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <>Delete selected User?</>
            <CloseIcon
              onClick={() => setDeleteModalOpen(false)}
              color="primary"
              sx={{ cursor: "pointer" }}
            />
          </DialogTitle>

          <DialogContent>
            <Typography>
              Are you sure you want to delete {rowToDelete?.userName}?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Grid justifyContent={"end"}>
              <Button
                color="error"
                variant="contained"
                onClick={(row) => handleDelete(rowToDelete)}
                sx={{ mr: 2 }}
              >
                Delete
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={() => setDeleteModalOpen(false)}
              >
                close
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>

        {/* Successful/Failed  API's snackbar */}
        {
          <SnackbarComponent
            message={snackbarOpen?.message}
            isOpen={snackbarOpen?.open}
            purpose={snackbarOpen?.severity}
            handleClick={handleClick}
          />
        }
      </Grid>
    </Card>
  );
};

export default Users;
